module.exports = __webpack_public_path__ + "static/media/gha_silver_blank.dc02e937.png";